// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Y6YdY","postfix":"styles_postfix__HzYgv","prefix":"styles_prefix__OJCML"};